"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var widget_react_1 = require("@livechat/widget-react");
var react_1 = __importStar(require("react"));
var HelpDesk_1 = __importDefault(require("./HelpDesk"));
var Widget_1 = __importDefault(require("./Widget"));
var LC_WIDGET_SELECTOR = '#chat-widget-container';
var LICENSE = '14625849';
var LiveChat = function (_a) {
    var customIcon = _a.customIcon, alwaysShow = _a.alwaysShow, _b = _a.license, license = _b === void 0 ? LICENSE : _b, _c = _a.chatBetweenGroups, chatBetweenGroups = _c === void 0 ? true : _c;
    var userData = (0, swr_hooks_1.useUser)().data;
    var balance = (0, swr_hooks_1.useBalance)().data;
    var changeHelpDeskStatus = (0, swr_hooks_1.useHelpDeskState)().changeHelpDeskStatus;
    var setUserDataToChat = (0, react_1.useCallback)(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (!userData)
            return;
        var LC_API = window.LC_API;
        var firstName = (_d = (_c = (_b = (_a = userData === null || userData === void 0 ? void 0 : userData.profile) === null || _a === void 0 ? void 0 : _a.getOne) === null || _b === void 0 ? void 0 : _b.profile) === null || _c === void 0 ? void 0 : _c.personal) === null || _d === void 0 ? void 0 : _d.firstName;
        var email = (_h = (_g = (_f = (_e = userData === null || userData === void 0 ? void 0 : userData.profile) === null || _e === void 0 ? void 0 : _e.getOne) === null || _f === void 0 ? void 0 : _f.profile) === null || _g === void 0 ? void 0 : _g.contacts) === null || _h === void 0 ? void 0 : _h.email;
        if (firstName)
            LC_API.set_visitor_name(firstName);
        if (email)
            LC_API.set_visitor_email(email);
        if (balance) {
            LC_API.set_custom_variables([
                {
                    name: 'Money balance',
                    value: "".concat((0, apps_shared_1.getCurrencySymbol)(balance === null || balance === void 0 ? void 0 : balance.currency), " ").concat((_j = Number(balance === null || balance === void 0 ? void 0 : balance.amount)) === null || _j === void 0 ? void 0 : _j.toFixed(2)),
                },
                {
                    name: 'Bonus balance',
                    value: "".concat((0, apps_shared_1.getCurrencySymbol)(balance === null || balance === void 0 ? void 0 : balance.currency), " ").concat((_k = (Number(balance === null || balance === void 0 ? void 0 : balance.totalAmount) - Number(balance.amount))) === null || _k === void 0 ? void 0 : _k.toFixed(2)),
                },
            ]);
        }
    }, [userData, balance]);
    var onChatReadyHandler = (0, react_1.useCallback)(function (data) {
        setUserDataToChat();
        var lcWidget = document.querySelector(LC_WIDGET_SELECTOR);
        if (!lcWidget)
            return;
        if (data.state.visibility !== 'maximized') {
            lcWidget.style.transform = 'translate(100px,0)';
            lcWidget.style.visibility = 'hidden';
        }
        else {
            lcWidget.style.transform = 'initial';
            lcWidget.style.visibility = 'visible';
        }
    }, [setUserDataToChat]);
    var onChatVisibilityChangedHandler = (0, react_1.useCallback)(function (data) {
        var lcWidget = document.querySelector(LC_WIDGET_SELECTOR);
        if (!lcWidget)
            return;
        if (data.visibility === 'maximized') {
            lcWidget.style.transform = 'initial';
            lcWidget.style.visibility = 'visible';
        }
        if (data.visibility === 'minimized') {
            document.querySelector(LC_WIDGET_SELECTOR);
            lcWidget.style.transform = 'translate(100px,0)';
            lcWidget.style.visibility = 'hidden';
        }
    }, []);
    var openLiveChat = (0, react_1.useCallback)(function () {
        var _a;
        var LC_API = window.LC_API;
        if (!LC_API.open_chat_window)
            changeHelpDeskStatus(true);
        else
            (_a = LC_API === null || LC_API === void 0 ? void 0 : LC_API.open_chat_window) === null || _a === void 0 ? void 0 : _a.call(LC_API);
    }, [changeHelpDeskStatus]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(widget_react_1.LiveChatWidget, { chatBetweenGroups: chatBetweenGroups, license: license, onReady: onChatReadyHandler, onVisibilityChanged: onChatVisibilityChangedHandler }),
        react_1.default.createElement(Widget_1.default, { onClickWidget: openLiveChat, customIcon: customIcon, alwaysShow: alwaysShow }),
        react_1.default.createElement(HelpDesk_1.default, null)));
};
exports.default = LiveChat;
